import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import API_URLS from "../config/apiConfig";
import swal from "sweetalert";
import PageDetails from "./PageDetails";
import CourseDetailSidebar from "./CourseDetailSidebar";
import ChapterDetails from "./ChapterDetails";

const CourseDetails = () => {
  const authToken = localStorage.getItem("token");
  const location = useLocation();
  const [courses, setCourses] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const queryParams = new URLSearchParams(location.search);

  const fetchCourseDetails = async () => {
    const course_id = queryParams.get("course_id");
    try {
      const response = await axios.post(
        `${API_URLS.COURSES_FULL_DETAIL}?course_id=${course_id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data.success === 1) {
        setCourses(response.data.courseData || []);
       // console.log(response.data.courseData);
        const firstPage =
        response.data.courseData[0]?.chapters[0]?.pages[0] || null;
        setSelectedPage(firstPage);
      } else {
        swal("Error", response.data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  useEffect(() => {
    fetchCourseDetails();
  }, []);

  const handleChapterSelect = (chapter) => {

    if (selectedChapter?.id === chapter.id) {
      // If the same chapter is selected, ensure re-render
      setSelectedChapter(null); // Temporarily set to null
      setTimeout(() => setSelectedChapter(chapter), 0); // Set it back after a moment
    } else {
      // New chapter selected
      setSelectedChapter(chapter);
    }
    setSelectedPage(null); 
  };

  const handlePageSelect = (page) => {   
    if (selectedPage?.id === page.id) {
      // If the same chapter is selected, ensure re-render
      setSelectedPage(null); // Temporarily set to null
      setTimeout(() => setSelectedPage(page), 10); // Set it back after a moment
    } else {
      // New chapter selected
      setSelectedPage(page);
    }
 
    setSelectedChapter(null); // Clear selected chapter when a page is selected
  };
  
  
  return (
    <div className="container-fluid">
      <div className="row mt-4">
      
        <>
          {selectedChapter && (
            <ChapterDetails
              selectedChapter={selectedChapter}
             
            />
          )}
          {selectedPage && (
            <PageDetails
              selectedPage={selectedPage}
             
            />
          )}

          <CourseDetailSidebar
          courses={courses}
          onChapterSelect={handleChapterSelect}
          onPageSelect={handlePageSelect}
          selectedChapter={selectedChapter}
          selectedPage={selectedPage}

        />
        </>
      </div>
    </div>
  );
};

export default CourseDetails;
